import { PreferencesModal } from '../../pages/Settings/components/PreferencesModal';
import { usePreferencesPrompt } from './usePreferencesPrompt';

export const PreferencesPrompt = () => {
  const {
    showPrompt,
    multiSelectInput,
    selectedPreferences,
    isPreferencesUpdating,
    handleUpdatePreferences,
    handleClose,
  } = usePreferencesPrompt();

  if (!showPrompt || !multiSelectInput) {
    return null;
  }

  return (
    <PreferencesModal
      isUpdating={isPreferencesUpdating}
      multiSelectInput={multiSelectInput}
      onClose={handleClose}
      onUpdate={handleUpdatePreferences}
      selectedValues={selectedPreferences}
    />
  );
};
